/* eslint-disable */
import React from 'react';
import { useSelector, RootStateOrAny } from 'react-redux';
import * as lib from '~/dependencies';
import {
  ListActiveIntegrations,
  ContactIntegrated,
  ContactIntegratedList,
  CallId,
  IntegrationId,
} from '~/interfaces/integrations';
import ExpansibleContacts from '../ExpansibleContacts';

type Props = {
  callId: CallId;
  /**
   * The user's default integration to be displayed
   */
  viewIntegrationId?: IntegrationId;
};

export default function CallerInsights({ callId, viewIntegrationId }: Props) {
  const connectedIntegrations: ListActiveIntegrations = useSelector(
    (state: RootStateOrAny) => state.integrations?.accountIntegrations
  );

  const allCrmContacts: ContactIntegratedList = useSelector(
    (state: RootStateOrAny) => state.integrations.contacts
  );

  // Group contacts by integrations, prioritizing viewIntegrationId, which is the user's default integration
  const contactsGroupedByCrmintegrationId = lib._.chain(allCrmContacts)
    .filter(
      (c: ContactIntegrated) =>
        c.callId === callId &&
        (viewIntegrationId
          ? c.integrationId === viewIntegrationId
          : c.integrationId === Number(connectedIntegrations[0].id))
    )
    .groupBy('integrationId')
    .value();

  return (
    <>
      {lib._.map(
        contactsGroupedByCrmintegrationId,
        (contacts: ContactIntegratedList, integrationId: IntegrationId) => {
          return <ExpansibleContacts key={integrationId} contacts={contacts} />;
        }
      )}
    </>
  );
}
